import gql from 'graphql-tag';

const getTagsForZoneQuery = gql`
  query tagsForZone($zoneId: ObjectId!) {
    tags: tagsForZone(zoneId: $zoneId) {
      _id
      name
      color
    }
  }
`;

const createTagMutation = gql`
  mutation createTag($name: String!, $zoneId: ObjectId!, $color: String) {
    createTag(name: $name, zoneId: $zoneId, color: $color) {
      _id
      name
      color
      zoneId
    }
  }
`;

const updateTagMutation = gql`
  mutation updateTag($_id: ObjectId!, $name: String!, $color: String) {
    updateTag(_id: $_id, name: $name, color: $color) {
      _id
      name
      color
      zoneId
    }
  }
`;

const deleteTagMutation = gql`
  mutation deleteTag($_id: ObjectId!) {
    deleteTag(_id: $_id) {
      _id
      name
      color
      zoneId
    }
  }
`;

export {
  getTagsForZoneQuery,
  createTagMutation,
  updateTagMutation,
  deleteTagMutation
}
